<template>
  <section class="banner-club-section">
    <div class="banner-shadow"></div>
    <div class="banner-club">
      <img src="@/assets/img/customersClub/shopmobile.png" alt="" />
    </div>
  </section>
  <div class="page-container">
    <h1>تخفیفات برتر</h1>
    <offerSlider></offerSlider>
    <div class="title">
      <hr class="title-separator" />
    </div>
    <section class="categoryList-section">
      <categorySlider :categoryList="offersCategory"></categorySlider>
    </section>
    <section class="offers-list-section">
      <ul class="offers-list">
        <template v-for="(categoryItem, index) in offersCategory" :key="index">
          <li>
            <p :id="categoryItem" class="category-title">{{ categoryItem }}</p>
            <template v-for="(item, index2) in offersList" :key="index2">
              <offerCard
                :offerData="item"
                v-if="item.category == categoryItem"
              ></offerCard>
            </template>
          </li>
        </template>
      </ul>
    </section>
  </div>
  <BottomNavigation></BottomNavigation>
</template>

<script>
import BottomNavigation from "@/components/BottomNavigation";
import offerCard from "@/components/offerCard";
import offerSlider from "@/components/offerSlider";
import categorySlider from "@/components/categorySlider";
import { offersData } from "@/repo/offers.js";
export default {
  name: "customersClubPage",
  mixins: [offersData],
  components: {
    BottomNavigation,
    offerCard,
    offerSlider,
    categorySlider,
  },
};
</script>


<style lang="css" scoped>
@import url(@/assets/style/public-style/public-style.css);
@import url(@/assets/style/pages/customersClub/customersClub.css);
</style>